import React from 'react';

interface AuthTypeBadgeProps {
  isSSO: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2 py-1 text-xs',
  lg: 'px-3 py-1 text-sm',
};

export function AuthTypeBadge({isSSO, size = 'md'}: AuthTypeBadgeProps) {
  if (isSSO) {
    return <span className={`${sizeClasses[size]} font-medium rounded bg-purple-100 text-purple-800`}>SSO</span>;
  }

  return <span className={`${sizeClasses[size]} font-medium rounded bg-gray-100 text-gray-800`}>Password</span>;
}
